export const formats = {
    date: 'YYYY-MM-DD',
};
